<div class="flex-container">
  <div class="section-head">
    <h2 class="section-title">Bénéficiaires</h2>

    <div class="section-actions">
      <button
        type="button"
        [attr.data-modal-target]="addBeneficiaireModalId"
        [attr.data-modal-toggle]="addBeneficiaireModalId"
        class="tp-btn-primary">
        Ajouter un bénéficiaire
      </button>

      <button
        type="button"
        [attr.data-modal-target]="importCsvModalId"
        [attr.data-modal-toggle]="importCsvModalId"
        class="tp-btn-outline">
        Importer plusieurs bénéficiaires
      </button>
    </div>
  </div>

   <!-- Modal Import CSV -->
<div id="{{importCsvModalId}}" tabindex="-1" aria-hidden="true" class="csv-import-modal hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
  <div class="im-wrap">
    <div class="im-panel">

      <!-- En-tête -->
      <div class="im-head">
        <div>
          <h3 class="im-title">Importer plusieurs bénéficiaires</h3>
          <p class="im-sub">Ajoutez vos bénéficiaires en une seule fois à partir d'un fichier CSV.</p>
        </div>
        <button type="button" class="im-close" (click)="closeImportCsvModal()" [disabled]="isUploading" aria-label="Fermer">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>

      <div class="im-body">

        <!-- Zone de dépôt -->
        <label
          for="csv-file-input"
          class="im-drop"
          [class.is-dragging]="isDragging"
          [class.has-file]="csvFileName"
          (dragover)="onCsvDragOver($event)"
          (dragleave)="onCsvDragLeave($event)"
          (drop)="onCsvDrop($event)">
          <span class="im-drop-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path></svg>
          </span>
          <ng-container *ngIf="!csvFileName; else fileChosen">
            <span class="im-drop-title"><strong>Cliquez pour choisir un fichier</strong> ou glissez-le ici</span>
            <span class="im-drop-hint">Format .csv — colonnes : lastName, firstName, email, phoneNumber</span>
          </ng-container>
          <ng-template #fileChosen>
            <span class="im-drop-title"><strong>{{ csvFileName }}</strong></span>
            <span class="im-drop-hint">Cliquez pour choisir un autre fichier</span>
          </ng-template>
          <input id="csv-file-input" type="file" accept=".csv" (change)="onCsvSelected($event)" hidden />
        </label>

        

        <!-- Résultat de l'analyse -->
        <div *ngIf="totalCount > 0" class="im-result">
          <div class="im-summary">
            <div class="im-stats">
              <span class="im-stat">Total <strong>{{ totalCount }}</strong></span>
              <span class="im-stat im-stat--ok">Valides <strong>{{ validCount }}</strong></span>
              <span class="im-stat im-stat--ko" *ngIf="invalidCount > 0">Invalides <strong>{{ invalidCount }}</strong></span>
            </div>
            <div class="im-per-page">
              <label for="itemsPerPage">Lignes par page</label>
              <select id="itemsPerPage" [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
              </select>
            </div>
          </div>

          <div *ngIf="invalidCount > 0" class="im-alert">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
            Corrigez les lignes en rouge dans votre fichier puis importez-le à nouveau.
          </div>

          <div class="im-table-wrap">
            <table class="im-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Nom</th>
                  <th>Prénom</th>
                  <th>Email</th>
                  <th>Téléphone</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let result of paginatedResults; let i = index" [class.is-invalid]="!result.isValid">
                  <td class="im-num">{{ startIndex + i + 1 }}</td>
                  <td>{{ result.employee.lastName || '—' }}</td>
                  <td>{{ result.employee.firstName || '—' }}</td>
                  <td>{{ result.employee.email || '—' }}</td>
                  <td>{{ result.employee.phoneNumber || '—' }}</td>
                  <td>
                    <span *ngIf="result.isValid" class="im-badge im-badge--ok">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      Valide
                    </span>
                    <div *ngIf="!result.isValid" class="im-errors">
                      <span *ngFor="let err of result.errors" class="im-badge im-badge--ko">{{ err }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="im-pager" *ngIf="totalPages > 1">
            <span>Affichage de {{ startIndex + 1 }} à {{ endIndex }} sur {{ totalCount }}</span>
            <div class="im-pager-btns">
              <button type="button" class="im-page-btn" [disabled]="currentPage === 1" (click)="previousPage()">← Précédent</button>
              <button type="button" *ngFor="let page of visiblePages" class="im-page-btn" [class.is-current]="page === currentPage" (click)="goToPage(page)">{{ page }}</button>
              <button type="button" class="im-page-btn" [disabled]="currentPage === totalPages" (click)="nextPage()">Suivant →</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Pied -->
      <div class="im-foot">
        <button type="button" class="tp-btn-secondary" (click)="closeImportCsvModal()" [disabled]="isUploading">
          Annuler
        </button>
        <button type="button" class="tp-btn-primary" [disabled]="!canSendToBack || isUploading" (click)="sendCsvToBack()">
          <ng-container *ngIf="!isUploading">
            Importer {{ validCount > 0 ? validCount + ' bénéficiaire(s)' : '' }}
          </ng-container>
          <ng-container *ngIf="isUploading">
            <svg class="im-spin" width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25"></circle><path fill="currentColor" opacity="0.75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            Envoi en cours...
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>


  <div class="tp-card">
    <div class="tp-toolbar">
      <div class="tp-search">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="20" y1="20" x2="16.65" y2="16.65"></line></svg>
        <input type="text" [value]="searchQuery" (input)="filterTable($event)" placeholder="Rechercher ..." />
      </div>
    </div>

    <!-- Barre de sélection multiple -->
    <div *ngIf="checkedRows.length > 1" class="selection-bar">
      <span class="selection-count">{{ checkedRows.length }} bénéficiaire(s) sélectionné(s)</span>
      <div class="selection-actions">
        <button type="button" class="tp-btn-primary tp-btn-sm" (click)="chargeChecked()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path></svg>
          Charger
        </button>
        <button type="button" class="tp-btn-danger tp-btn-sm" (click)="deleteChecked()" [disabled]="isDeleting">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"></path><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
          <span *ngIf="!isDeleting">Supprimer</span>
          <span *ngIf="isDeleting">Suppression...</span>
        </button>
        <button type="button" class="tp-btn-secondary tp-btn-sm" (click)="clearSelection()">Annuler</button>
      </div>
    </div>

    <div class="tp-table-wrap">
      <table class="tp-table">
        <thead>
          <tr>
            <th class="col-check">
              <input type="checkbox" class="tp-checkbox" [checked]="allPageChecked" (change)="toggleAllPage()" aria-label="Tout sélectionner" />
            </th>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Téléphone</th>
            <th>Email</th>
            <th>Role</th>
            <th>Statut</th>
            <th class="col-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedRows; trackBy: trackByEmail" [class.is-checked]="isChecked(row)">
            <td class="col-check">
              <input type="checkbox" class="tp-checkbox" [checked]="isChecked(row)" (change)="toggleRow(row)" aria-label="Sélectionner" />
            </td>
            <td>{{ row.lastName }}</td>
            <td>{{ row.firstName }}</td>
            <td>{{ row.phoneNumber }}</td>
            <td>{{ row.email }}</td>
            <td>{{ row.role }}</td>
            <td>
              <span class="tp-badge" [class.tp-badge--success]="!isInactive(row)" [class.tp-badge--danger]="isInactive(row)">
                <svg *ngIf="!isInactive(row)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                <svg *ngIf="isInactive(row)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                {{ isInactive(row) ? 'Inactif' : 'Actif' }}
              </span>
            </td>
            <td class="col-center">
              <app-custom-action [rowData]="row" (charge)="handleCharge($event)" (delete)="handleDelete($event)"></app-custom-action>
            </td>
          </tr>

          <tr *ngIf="!visibleRows.length">
            <td colspan="8" class="tp-empty">Aucun bénéficiaire trouvé.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="tp-footer" *ngIf="tableTotalPages > 1">
      <span>{{ visibleRows.length }} bénéficiaire(s)</span>
      <div class="tp-pager">
        <button type="button" class="tp-page-btn" [disabled]="tablePage === 1" (click)="tableGoTo(tablePage - 1)">← Précédent</button>
        <button type="button" *ngFor="let p of tablePages" class="tp-page-btn" [class.is-current]="p === tablePage" (click)="tableGoTo(p)">{{ p }}</button>
        <button type="button" class="tp-page-btn" [disabled]="tablePage === tableTotalPages" (click)="tableGoTo(tablePage + 1)">Suivant →</button>
      </div>
    </div>
  </div>
</div>


<div>
  <app-modal
    [modalId]="addBeneficiaireModalId"
    title="Ajouter un bénéficiaire"
    [fields]="beneficiaireFields"
    (formSubmit)="handleBeneficiaireSubmit($event)">
  </app-modal>
</div>

<button
  type="button"
  id="charge-modal-trigger"
  data-modal-target="charge-modal"
  data-modal-toggle="charge-modal"
  class="hidden">
</button>


<div id="charge-modal" tabindex="-1" aria-hidden="true"
     class="hidden fixed top-0 right-0 left-0 z-50 w-full h-full flex items-center justify-center">
  <div class="tp-modal">
    <h3 class="tp-modal-title">Transfert de titres</h3>

    <form [formGroup]="chargeForm">
      <label class="tp-label">{{ amountLabel }}</label>
      <input type="number" formControlName="days" class="tp-input" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
      <div *ngIf="chargeForm.get('days')?.hasError('notPositive') && chargeForm.get('days')?.touched" class="text-red-600 text-xs mt-1">
        Le nombre de jours doit être supérieur à 0.
      </div>
      <div class="form-outline mb-4">
        <p class="text-sm text-gray-500 dark:text-gray-500">Montant total: <strong class="text-gray-900 dark:text-gray-500">{{amounToTransfer | number:'1.0-0'}} XOF</strong></p>
        <p class="text-sm text-gray-500 dark:text-gray-500">Solde restant: <strong [ngClass]="{'text-red-600': errorBalance, 'text-gray-900 dark:text-gray-500': !errorBalance}">{{balance | number:'1.0-0'}} XOF</strong></p>
      </div>

      <div class="tp-modal-actions">
        <button
          type="button"
          class="tp-btn-secondary"
          data-modal-hide="charge-modal"
          (click)="onCancel()">
          Annuler
        </button>

        <button
          type="button"
          class="tp-btn-primary"
          data-modal-hide="charge-modal"
          [disabled]="!chargeForm.valid"
          (click)="onConfirmTransfer()">
          Charger
        </button>
      </div>
    </form>
  </div>
</div>


<button
  type="button"
  id="delete-modal-trigger"
  data-modal-target="delete-modal"
  data-modal-toggle="delete-modal"
  class="hidden">
</button>


<div id="delete-modal" tabindex="-1" aria-hidden="true"
     class="hidden fixed top-0 right-0 left-0 z-50 w-full h-full flex items-center justify-center">
  <div class="tp-modal">
    <h3 class="tp-modal-title">Confirmation de suppression</h3>

    <p class="tp-modal-text">
      Êtes-vous sûr(e) de vouloir supprimer le(s) bénéficiaire(s) sélectionné(s) ?
    </p>

    <div class="tp-modal-actions">
      <button type="button" class="tp-btn-secondary" data-modal-hide="delete-modal">
        Non
      </button>
      <button type="button" data-modal-hide="delete-modal" (click)="onConfirmDelete()" class="tp-btn-danger">
        Oui, supprimer
      </button>
    </div>
  </div>
</div>


<p-toast></p-toast>